import { useDispatch } from "react-redux";
import { UPDATE_FILTER } from "@/redux/types/auth.types";
import useFilterStore from "@/stores/useFilterStore";
import classes from "../filter.module.scss";

const FilterSearch = ({ filter, search, setSearch, setOpenFilter }) => {
	const dispatch = useDispatch();
	const { updateFilter } = useFilterStore();

	const handleSearch = () => {
		const newFilter = { ...filter, search, application: "", parameter: "" };

		dispatch({ type: UPDATE_FILTER, payload: { filter: newFilter } });
		updateFilter({ search, application: "", parameter: "" });
		setOpenFilter(false);
	};

	const handleClearSearch = () => {
		const newFilter = { ...filter, search: "", application: "", parameter: "" };

		dispatch({ type: UPDATE_FILTER, payload: { filter: newFilter } });
		updateFilter({ search: "", application: "", parameter: "" });
		setSearch("");
	};

	const handleKeyDown = (e) => {
		if (e.key === "Enter") {
			handleSearch();
		}
	};

	return (
		<>
			<hr className={`${classes.divider} ${classes.searchMobile}`} />

			<div className={classes.searchContainer}>
				<input
					type="text"
					placeholder="Buscar"
					value={search || ""}
					onKeyDown={handleKeyDown}
					onChange={(e) => {
						setSearch(e.target.value);
						if (e.target.value === "") {
							handleClearSearch();
						}
					}}
				/>
				<div className={classes.buttonSearch} onClick={handleSearch} />
			</div>

			<hr className={classes.divider} />
		</>
	);
};

export default FilterSearch;
